import { createContext, useContext, useState, ReactNode } from "react";

export type AgenceSelect = {
  CODAGE: string;
  LIBELLE: string;
 // Adresse: string;
    VILLE: string;
    //Pays: string;
    TELEPH: string;
    BPOSTE: string
    LICENCE: string;
    BANQUE:string;
    NUMCON: string;
    NUMREG: string;
  // ajoute ici toutes les infos que tu veux garder
};

type AgenceContextType = {
  agence: AgenceSelect | null;
  setAgence: (ag: AgenceSelect) => void;
};

const AgenceContext = createContext<AgenceContextType | undefined>(undefined);

export const AgenceProvider = ({ children }: { children: ReactNode }) => {
  const [agence, setAgence] = useState<AgenceSelect | null>(null);

  return (
    <AgenceContext.Provider value={{ agence, setAgence }}>
      {children}
    </AgenceContext.Provider>
  );
};
export const useAgence = () => {
  const ctx = useContext(AgenceContext);
  if (!ctx) {
    throw new Error("useAgence must be used inside AgenceProvider");
  }
  return ctx;
};